import { Button } from '@act/storybook';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AdminDrawerProps {
  title?: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  children: React.ReactNode;
  extraContent?: React.ReactNode;
}

export const AdminDrawer = ({
  open,
  setOpen,
  children,
  title,
  extraContent,
}: AdminDrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
        }
      }}
      PaperProps={{
        sx: {
          width: 530,
          padding: '20px',
          height: '100%',
          overflowY: 'auto',
          boxSizing: 'border-box',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 3,
          alignSelf: 'stretch',
          pb: 3,
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="headlineMedium">{title}</Typography>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            '&:hover': {
              cursor: 'pointer',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>{children}</Box>
      {extraContent && <Box sx={{ mt: 5 }}>{extraContent}</Box>}
    </Drawer>
  );
};

type AdminDrawerFormProps = AdminDrawerProps & {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
};

export const AdminDrawerForm = ({
  open,
  setOpen,
  children,
  onSubmit,
  title,
  extraContent,
}: AdminDrawerFormProps) => {
  return (
    <AdminDrawer
      open={open}
      setOpen={setOpen}
      title={title}
      extraContent={extraContent}
    >
      <form onSubmit={onSubmit}>
        {children}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            width: '100%',
            justifyContent: 'flex-end',
          }}
        >
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" type="submit" debounced>
            Save
          </Button>
        </Box>
      </form>
    </AdminDrawer>
  );
};
